import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
  offset: number
  timeZone: string
}

export default function useAgeAndGenderCounting({enabled, filter, start, end, offset, timeZone}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_PERSONALIZED_AGE_GENDER_COUNTING, filter, enabled, start, end],
    queryFn: async () => (await api.reports.getPersonalizedAgeAndGenderCounting({filter, start, end, offset, timeZone})).data.data,
  })

  return query
}
